// Utility funkcie pre prácu s avatarmi cez Supabase Storage

import { createClient } from "@supabase/supabase-js";

export type TypAvatara = "hrac" | "navrh" | "profil";

export interface AvatarData {
  avatar_url: string | null;
  avatar_verzia: number;
}

export interface AvatarOsobyProps {
  typ: TypAvatara;
  id: string;
  meno: string;
  avatarData?: AvatarData;
  pozicia?: string;
  className?: string;
  fallbackClassName?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

// Získanie cesty v Supabase Storage
export function getStoragePath(typ: TypAvatara, id: string): string {
  const prefix =
    typ === "hrac" ? "players" : typ === "navrh" ? "navrhy" : "profily";
  return `${prefix}/${id}`;
}

// Získanie verejnej URL pre hráčov (public bucket)
export function getPublicAvatarUrl(id: string): string {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
  return `${supabaseUrl}/storage/v1/object/public/avatary/players/${id}`;
}

// Vytvorenie signed URL pre profily a návrhy (private)
export async function getSignedAvatarUrl(
  typ: TypAvatara,
  id: string,
): Promise<string | null> {
  if (typ === "hrac") {
    return getPublicAvatarUrl(id);
  }

  try {
    const supabase = createClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL!,
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    );

    const { data, error } = await supabase.storage
      .from("avatary")
      .createSignedUrl(getStoragePath(typ, id), 3600); // 1 hodina expirácia

    if (error) {
      return null;
    }

    return data.signedUrl;
  } catch {
    return null;
  }
}

// Jednotná placeholder cesta  todo
export const PLACEHOLDER_AVATAR = "/image/avatar/PlayerAvatar.png";

// Zistenie, či má osoba reálny avatar
export function maRealnyAvatar(avatarData?: AvatarData): boolean {
  return !!(avatarData?.avatar_url && avatarData.avatar_verzia > 0);
}
